import { Outlet } from 'react-router-dom-v5-compat';

import Footer from '../Footer';
import Header from '../Header/Header';
import Main from '../Main/Main';
import { ErrorBoundary } from '../ErrorBoundary';

type LayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <Header />
      <Main>
        <ErrorBoundary>
          {children}
          <Outlet />
        </ErrorBoundary>
      </Main>
      <Footer />
    </>
  );
}
